import { Pipe, PipeTransform } from '@angular/core';
import { LocalEntityService } from '../shared/services/index';

@Pipe({
    name: 'localEntity',
    standalone: false
})
export class LocalEntityPipe implements PipeTransform {
  public localEntities: any;

  constructor(private service: LocalEntityService) {
    this.service.getLocalEntities().subscribe((data) => {
      this.localEntities = data;
    });
  }

  transform(id: string): any {
    return this.service.getValue(id, this.localEntities);
  }
}
